import { useMessageApi } from "../../../provider/AntdNotification";
import ButtonWrapper from "../../components/reuseComp/ButtonWrapper";
import { Form, Input, Switch, Spin, Select } from "antd";
import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import {
  useSubAdminCreate,
  useSubAdminDetails,
} from "../../../hooks/api/subAdmins/hooks";
import { subAdminModule } from "../../../constants/api_endpoints";

interface Props {
  qData: any;
  id?: any;
}

const SubAdminFrom: React.FC<Props> = ({ qData, id }) => {
  const [form] = Form.useForm();
  const message = useMessageApi();
  const navigate = useNavigate();
  const isEditPage = Boolean(id);

  const { mutate: saveSubAdmin, isPending } = useSubAdminCreate({ qData });
  const { data: subAdminDetails, isLoading } = useSubAdminDetails(id);

  useEffect(() => {
    if (isEditPage && subAdminDetails?.data) {
      const subAdmin = subAdminDetails.data;

      form.setFieldsValue({
        name: subAdmin.name,
        email: subAdmin.email,
        phone: subAdmin.phone,
        rights: subAdmin.rights,
        status: subAdmin.status,
      });
    }
  }, [isEditPage, subAdminDetails, form]);

  const handleSave = async () => {
    try {
      const values = await form.validateFields();

      const payload = isEditPage ? { ...values, _id: id } : values;

      console.log(payload, "aaaa");

      saveSubAdmin(payload, {
        onSuccess: () => {
          message.success(
            isEditPage
              ? "Sub Admin updated successfully"
              : "Sub Admin created successfully"
          );
          navigate(-1);
        },
        onError: (err: any) => {
          const msg =
            err?.response?.data?.message ||
            err?.message ||
            "Failed to save Sub Admin";

          message.error(msg);
        },
      });
    } catch (err) {
      console.error(err);
    }
  };

  const showSpinner = isEditPage && isLoading;

  return (
    <div>
      <div className="bg-[#F9F9F9] p-3 md:p-6 rounded-2xl shadow-sm mb-6">
        <Spin
          spinning={showSpinner}
          tip="Loading sub admin details..."
          size="large"
        >
          <Form
            layout="vertical"
            form={form}
            className="grid md:grid-cols-2 gap-3"
          >
            <Form.Item
              label="Name"
              name="name"
              rules={[{ required: true, message: "Please enter name" }]}
              className=""
            >
              <Input placeholder="Name" />
            </Form.Item>

            <Form.Item
              label="Email"
              name="email"
              rules={[{ required: true, message: "Please enter email" }]}
              className=""
            >
              <Input placeholder="Email" />
            </Form.Item>

            <Form.Item
              label="Phone"
              name="phone"
              rules={[{ required: true, message: "Please enter phone" }]}
              className=""
            >
              <Input placeholder="Phone" />
            </Form.Item>
            <Form.Item
              label="User Password"
              name="password"
              rules={[
                {
                  required: !isEditPage,
                  message: "Please enter user password",
                },
              ]}
            >
              <Input.Password placeholder="User Password" />
            </Form.Item>
            <Form.Item
              label="Select Rights"
              name="rights"
              rules={[{ required: true, message: "Please select an rights" }]}
            >
              <Select
                placeholder="Select rights"
                loading={subAdminModule.length === 0}
                showSearch
                mode="multiple"
                optionFilterProp="children"
              >
                {subAdminModule?.map((v) => (
                  <Select.Option key={v} value={v}>
                    {v}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>

            <Form.Item
              label="Status"
              name="status"
              valuePropName="checked"
              rules={[{ required: true, message: "Please select status" }]}
            >
              <Switch checkedChildren="Active" unCheckedChildren="Inactive" />
            </Form.Item>
          </Form>
        </Spin>
      </div>
      <div className="flex justify-start gap-3 mt-7 sticky bottom-5">
        <ButtonWrapper type="primary" onClick={handleSave} loading={isPending}>
          Save
        </ButtonWrapper>
        <ButtonWrapper onClick={() => navigate(-1)}>Cancel</ButtonWrapper>
      </div>
    </div>
  );
};

export default SubAdminFrom;
